import { controllerSchedulesHe } from "./controllerSchedules";

const he = {
  ...controllerSchedulesHe,
  /** Global */
  WELCOME: "ברוכים הבאים",
  HI: "היי",
  LANG: "שפה",
  BACK_TO_HOME_PAGE: "חזרה לדף הבית",
  INSTALL_APP: "התקן אפליקציה",
  NUM_IS_GREATER_ERROR: "הזן מספר קטן מ",
  NUM_IS_LESS_ERROR: "הזן מספר גדול מ",
  DETAILS: "פרטים",
  CLEAR: "איפוס",
  SAVE: "שמור",
  UPLOAD: "העלאה",
  NEW: "חדש",
  CANCEL: "ביטול",
  EDIT: "עריכה",
  DELETE: "מחיקה",
  LOGOUT: "התנתק",
  ACCEPT: "אישור",
  ERROR: "שגיאה",
  CLOSE: "סגור",
  GOOD_AFTERNOON: "צהריים טובים",
  GOOD_EVENING: "ערב טוב",
  GOOD_NIGHT: "לילה טוב",
  GOOD_MORNING: "בוקר טוב",
  PATH_EXISTS: "מזהה קיים במערכת - נא לבחור מזהה אחר",
  CREATED: "תאריך יצירה",
  NO_DATA: "אין מידע להצגה",
  QTY: "כמות",
  TYPE: "סוג",
  PRICE: "מחיר",
  TEMPLATES: "עיצוב",
  SEND: "שלח",
  WELCOME: "ברוכים הבאים",
  REFRES: "רענון",
  SEARCH: "חיפוש",
  SAVED_SUCCESS: "נשמר בהצלחה",
  LINK_COPY_SUCCESS: "קישור הועתק בהצלחה",
  UNLIMITED: "ללא הגבלה",
  ADMIN_AREA: "אזור מנהל",
  FREE: "חינם",
  REMOVE: "הסר",
  CONTINUE: "המשך",
  DELETE_INFO: "לאחר המחיקה לא יהיה ניתן לשחזר את המידע",
  DOWNLOAD: "הורדה",
  DOWNLOAD_DOCUMENT: "הורד מסמך",
  DOCUMENT: "מסמך",
  PAY_ATTENTION: "שים לב",
  SHOW: "הצג",
  DATE: "תאריך",
  SUNDAY: "ראשון",
  MONDAY: "שני",
  TUESDAY: "שלישי",
  WEDNESDAY: "רביעי",
  THURSDAY: "חמישי",
  FRIDAY: "שישי",
  SATURDAY: "שבת",
  HELLO: "שלום",
  LAST_ACTIVE: "פעולה אחרונה",
  COLOR: "צבע",
  EMPLOYEE: "עובד",
  DEPARTMENT_MANAGER: "מנהל מחלקה",
  BIZ_MANAGER: "מנהל עסק",
  INVENTORY: "מחסנאי",
  ROLE: "הרשאות",
  LINK_COPY_SUCCESSFULLY: "קישור הועתק בהצלחה",
  TEXT_COPY_SUCCESSFULLY: "טקסט הועתק בהצלחה",
  TABLE: "טבלה",
  CARDS: "כרטיסים",
  STATUS: "סטטוס",
  ADD: "הוסף",
  ALL: "הכל",
  FULL: "מלא",
  EMPTY: "ריק",
  GLOBAL: "כללי",
  EMP_AND_DATES: "שיבוץ וזמנים",
  PAYMENTS: "חשבונות",
  PROVIDERS_AND_PAYMENTS: "ספקים וחשבונות",
  EMPLOYEE_NAME: "עובד מבצעה",
  CREATE_GUID: "יצירת מזהה",
  CHECK_CONNECTED: "בדוק חיבור",
  NETWORK_CONNECTION_GUIDE_TITLE: "חיבור החיישן לרשת",
  NETWORK_CONNECTION_GUIDE_1: "כנס לחיפוש רשתות אלחוטיות בנייד או במחשב",
  NETWORK_CONNECTION_GUIDE_2: "מצע חיבור שנקרא 'MyBee'",
  NETWORK_CONNECTION_GUIDE_3: "לחץ על התחברות ורשום את הסיסמה שנמצא בגב החיישן",
  NETWORK_CONNECTION_GUIDE_4: "לאחר מכן יפתח לך דף התחברות",
  NETWORK_CONNECTION_GUIDE_4_1: "אם הדף לא נפתח לחץ כאן",
  NETWORK_CONNECTION_GUIDE_5: "בדף שנפתח אכנס את פרטי התחברות לרשת (שם הרשת וסיסמה)",
  NETWORK_CONNECTION_GUIDE_6: "שלח את הטופס ואמתן לחיבור החיישן לרשת",
  NETWORK_CONNECTION_GUIDE_6: "אם החיישן התחבר תקבל הודעה בדף 'Device connected to the internet.'",
  NETWORK_CONNECTION_GUIDE_7: "לחץ על בדוק חיבור בתחתית דף זה",
  SET_ALL_ASTERISK_ERROR: "נא למלא את כל השדות המסומנות בכוכבית*",
  TEST: "בדיקה",
  WS_IS_CONNECTED: "מחובר לשרת",
  WS_IS_DISCONNECTED: "מנותק מהשרת",
  NUMBER_MUST_BE_BETWEEN: "המספר צריך להיות בין",
  NUMBER_MUST_BE_GREATER_THAN: "המספר צריך להיות גדול מ",
  NUMBER_MUST_BE_LESS_THAN: "המספר צריך להיות קטן מ",
  SETTINGS_AND_ADMIN: "הגדרות וניהול",
  NO_PLUGIN: "אינך מורשה לפתוח קריאה - למידע נוסף נא לפנות לשרות לקוחות",
  HAS_TWO_FACTOR: "הפעל אימות דו שלבי",
  TWO_FACTOR_NEED_EMAIL_ERROR: 'יש להוסיף דוא"ל להפעלת אימות דו שלבי',
  TWO_FACTOR_CODE: "אימות דו שלבי",
  CODE: "הזן את הקוד שקבלת",
  TWO_FACTOR_SEND_EMAIL: 'קוד אימות נשלח לדוא"ל.',
  TWO_FACTOR_INPUT: 'יש להזין את הקוד להשלמת התהליך.',
  TWO_FACTOR_CODE_REQUIRED: "חובה להזין קוד אימות",
  SEND_AGAIN_TIMER: "לא קבלתי קוד",
  SEND_AGAIN: "שלח קוד שנית",
  SEND_CODE_SUCCESS: "קוד נשלח בהצלחה",
  SELECTED_LANG: "בחירת שפה",
  LANGUAGE: "שפה",
  HE: "עברית",
  EN: "אנגלית",
  AR: "ערבית",
  RU: "רוסית",
  CHANGE_LANG_SUCCESS: "שפה שונתה בהצלחה",
  CHANGE_LANG_ERROR: "לא הצלחנו לשנות את השפה, אנא נסה שנית",
  ICON: "אייקון",
  TITLE: "כותרת",
  URL: "כתובת אתר",
  // new
  NOTIFY_MAIL: 'דוא"ל להתראות',
  QR_NOT_FROM_SYS_ERROR: "QR לא מזוהה, נא לסרוק QR מערכת בלבד",
  HISTORY_AND_REPORTS: "היסטוריה ודוחות",
  INSTANT: "מיידי",
  MORE: "נוספים",
  BLACK_LIST_DIALOG: "משתמש חסום",
  DESIGN: "עיצוב",
  IS_ACTIVE: "פעיל",
  NICK_NAME: "כינוי",
  DESC_TITLE: "כותרת לתיאור",
  SUB_TITLE: "תת כותרת",
  WITHOUT: "ללא",
  MORNING: "בוקר טוב",
  NOON: "צהריים טובים",
  AFTER_NOON: 'אחה"צ טובים',
  EVENING: "ערב טוב",
  NIGHT: "לילה טוב",
  DAYS: "ימים",
  HOURS: "שעות",
  MINUTES: "דקות",
  SECONDS: "שניות",
  PORTAL: "פורטל",
  COPY: "שיכפול",
  PERMISSION_SUCCESS: "ההרשאה התקבלה",
  PERMISSION_ERROR: "הרשאה נדחתה",
  USER_PERMISSION_ERROR: "משתמש לא מאושר",
  DONT_ASK_AGAIN: "אל תשאל שוב",
  REMIND_NEXT_TIME: "הזכר לי פעם הבאה",
  DAILY: "יומי",
  WEEKLY: "שבועי",
  MONTHLY: "חודשי",
  YEARLY: "שנתי",
  WEEKS: "שבועות",
  YEARS: "שנים",
  MONTHS: "חודשים",
  EVERY: "כל",
  IN_DAYS: "בימים",
  IN_DAY: "ביום",
  IN_TIME: "בשעה",
  IN_MONTHS: "בחודש",
  IN: "ב",
  DOUBLE_CLICK_FOR_OPEN: "לחיצה כפולה לפתיחה",
  ENTER: "הקלד",
  FOR_CONFIRM_DELETION: "לאישור המחיקה",
  DATA_DOES_NOT_MATCH: "הערך לא תואם",
  REFRESH: "רענן",
  DESCRIPTION: "תיאור",
  PLATFORM: "פלטפורמה",
  IS_PRODUCTION: "Production",
  API: "API",
  BO: "פאנל ניהול",
  MC: "בקר",
  WEB: "אתר",
  SERVER: "שרת",
  YES: "כן",
  NO: "לא",
  ACTIVE: "פעיל",
  CLOSED: "סגור",
  HISTORY: " היסטוריה",
  UPDATE_SUCCESSFULLY: "עודכן בהצלחה",
  NONE: "ללא",
  FLAG: "דגל",
  STATUS_LED_POWER_CHANGE_IMMEDIATE: "*השינוי יתבצע באופן מיידי - ללא צורך בשמירה",
  NEW_BIZ: "עסק חדש",
  SELECTED_BIZ: "עסק נבחר",
  MENU: "תפריט",
  TIME: "זמן",
  SETTINGS: "הגדרות",
  GLOBAL_SETTINGS: "הגדרות כלליות",
  CLOSE_MENU: "סגור תפריט",
  UNITS: "יחידות",
  DISPLAY_TYPE: "סוג תצוגה",
  SHOW_FIELD: "שדות להצגה",
  USER_PALETTE_MODE: "מצב תצוגה",
  HIDE_FLOATING_NOTIFICATIONS: "הסתר התראות צפות",
  MASSAGE: "הודעה",
  EXPORT_EXCEL: "יצוא לאקסל",
  EXPORT_PDF: "הורד PDF",
  EXPORT: "יצוא",
  EXPORT_TABLE: "יצוא טבלה",
  INIT: "רענון מערכת",
  SYSTEM: "מערכת",
  CREATED_BY: "נוצר ע\"י",
  MEDIA_SIZE_BIG_ERROR: "הקובץ שנבחר חורג מהמגבלה המותרת",
  MEDIA_NOT_ALLOWED_ERROR: "קובץ לא ניתמך",
  MEDIA: "מדיה",
  NO_RESULTS: "לא נמצאו תוצאות",
  PILOT: "פיילוט",
  NOT_ACTIVE: "לא פעיל",
  BLOCKED: "חסום",
  PENDING_DELETE: "ממתין למחיקה",
  BIZ_STATUS: "סטטוס עסק",
  BIZ_TYPE: "סוג עסק",
  JANUARY: "ינואר",
  FEBRUARY: "פברואר",
  MARCH: "מרץ",
  APRIL: "אפריל",
  MAY: "מאי",
  JUNE: "יוני",
  JULY: "יולי",
  AUGUST: "אוגוסט",
  SEPTEMBER: "ספטמבר",
  OCTOBER: "אוקטובר",
  NOVEMBER: "נובמבר",
  DECEMBER: "דצמבר",
  SUMMARY: "סיכום",
  NUMBER: "מספר",
  SELECT_ALL: "בחר הכל",
  DESELECT_ALL: "נקה הכל",
  VALIDATION_DIALOG: "עצור לבדיקה",
  SENSITIVE_PLACE_INFO: "זהירות אתה נכנס למקום רגיש!",
  REQUEST_SENT_TO_MC: "בקשה נשלחה לבקר",

  /** Validations */
  REQUIRED: "שדה חובה",
  URL_ERROR: "נא להזין כתובת תקינה, לדוגמה :https://www.google.co.il",
  CEL_ISRAELI_ERROR: "נא להזין מספר פלאפון תקין",
  EMAIL_ERROR: 'נא להזין דוא"ל תקין',
  ONLY_NUMBER_ERROR: "נא להזין מספרים בלבד",
  PATH_ERROR:
    "נא להזין אותיות באנגלית ומספרים (מינימום 3 אותיות מקסימום 20 אותיות)",
  PASSWORD_ERROR:
    "מינימום שמונה תווים, לפחות אות אחת גדולה, אות קטנה אחת, ספרה אחת ותו מיוחד אחד",

  /** Plans */
  PLANS_MANAGEMENT: "ניהול תוכניות",
  servicesCall: "קריאות שירות",
  contactUs: "דואר",
  schedule: "לוח זמנים",
  PLANS: "תוכניות",
  maxClients: "כמות לקוחות",
  maxEmployees: "כמות עובדים",
  maxItems: "כמות ציוד",
  maxWebAppMessage: "כמות הודעות",
  EVERY_MONTH: "לחודש",
  SELECT_PLAN: "בחר תוכנית",
  ONLY_SYS_ADMIN: "מוצג למנהלי מערכת בלבד",
  SYS_NAME: "שם במערכת",
  PLAN_DETAILS: "תוכנית",
  WS_IS_NOT_CONNECTED: "המערכת אינה מחוברת לשרת. אנא נסה שוב בעוד מספר שניות",

  /** Dates Reports */
  DATES: "תאריכון",
  START_DATE: "תאריך התחלה",
  END_DATE: "תאריך סיום",
  CREATE_REPORT: "צור דוח",
  TODAY: "היום",
  THIS_WEEK: "השבוע",
  THIS_MONTH: "החודש",
  THIS_YEAR: "השנה",
  ALL_EMPLOYEES: "כל העובדים",
  PMT_TYPE: "סטטוס תשלום",
  ALL_PMT: "כל סוגי התשלום",
  ALL_STATUS: "כל הסטטוסים",
  //new
  MAX_METER_READ: "מדידה אחרונה",
  DAILY_AVERAGE: "ממוצע יומי",

  /** Login */
  LOGIN: "התחברות",
  CONNECT: "התחבר",
  USER_NAME: "שם משתמש",
  PASSWORD: "סיסמה",
  HAS_SIGNIN: "אין לכם עדין חשבון ?",
  SIGNIN_NOW: "פתחו חשבון",
  KEEP_LIGIN: "זכור אותי במחשב זה",
  REMEMBER_ME: "זכור אותי",
  LOGIN_ERROR: "שגיאת התחברות",
  LOGIN_SUCCESS: "התחברת בהצלחה",
  BIZ_SUCCESS: "עסק נפתח בהצלחה",

  /** Recommend */
  RECOMMEND: "המלצות",
  RECOMMEND_DESC: "תיאור ההמלצה",

  /** Templates */
  BASIC: "בסיסי",
  CLASSIC: "קלאסי",
  WAVES: "גלים",
  BUBBLE: "בועות",
  TEMP_TYPE_ID: "בחר עיצוב",
  CLASSIC_1: "קלאסי 1",
  DESIGN_1: "עיצוב 1",

  /** Signup */
  SIGNUP: "ייאלה בואו נתחיל",
  WELCOME: "ברוכים הבאים",
  SIGNUP_NFO: "הרשמה קצרה ואתם בפנים",
  USER_DETAILS: "פרטי משתמש",
  BIZ_DETAILS: "פרטי עסק",
  BIZ_TEL: "טלפון בעסק",
  BIZ_EMAIL: 'דוא"ל בעסק',
  BIZ_DESC: "קצת מידע על העסק",
  VALID_PASSWORD: "אימות סיסמה",
  EMAIL_FOR_RESET_PASSWORD: 'דוא"ל לשחזור סיסמה',
  HAS_LOGIN: "יש לכם כבר חשבון ?",

  //** Analytics */
  ANALYTICS: "אנליטיקס",

  /** Private Area */
  PRIVATE_AREA: "אזור אישי",

  /** plans */
  MAX_CLIENTS: "כמות לקוחות",
  MAX_EMPLOYEES: "כמות עובדים",
  MAX_ITEMS: "כמות ציוד",
  MAX_WEBAPPMESSAGE: "כמות הודעות",
  YOUR_PLAN: "התוכנית שלך",
  DELETE_PLAN: "האם אתה בטוח שברצונך למחוק חבילה זה ?",

  /** plugins */
  PLUGINS: "תוספים",
  PLUGINS_MANAGER: "ניהול תוספים",
  MAX_QTY: "כמות מקסימלית",
  PROPERTIES: "מאפיינים",
  SELECT_PLUGIN: "הוסף תוסף",
  REMOVE_PLUGIN: "הסר תוסף",
  REMOVE_PLUGIN_ASK: "האם אתה בטוח שברצונך להסיר את",
  REMOVE_PLUGIN_INFO:
    "המידע שלך ישמר אך לא יהיה לך גישה אליו ולכלל האפשרויות בתוסף זה",
  REMOVE_AFTER_SAVE: "שים לב- הסרת התוסף תתבצעה רק לאחר לחיצה על כפתור המשך",
  DELETE_PLUGIN: "האם אתה בטוח שברצונך למחוק תוסף זה?",
  PLUGIN_DETAILS: "תוסף",

  /** desktop */
  DASHBOARD: "בית",
  STATUS_SERVICES_CALL: "סטטוס קריאות שירות",
  SUM: 'סה"כ',
  NOT_WORK_DT: "ללא תאריך עבודה",
  NO_INVOICE_NUMBER: "ללא חשבונית",
  TOTAL_EXPENSES_PROVIDERS: "הוצאות ספקים",
  TOTAL_REVENUE: 'סה"כ הכנסות',
  DEVICE_ACTIVE: "פעילים",
  DEVICE_LOW_EFFECTIVE: "יעילות נמוכה",
  DEVICE_NOT_ACTIVE: "כבויים",
  DEVICE_FAULT: "תקולים",
  // new
  REVENUE: "הכנסות",
  CHLORINE_METERS_WEEKLY: "מונה כלור",
  GAS_METERS_WEEKLY: "מונה גז",
  ELECTRICITY_METERS_WEEKLY: "מונה חשמל",
  WATER_METERS_WEEKLY: "מונה מים",
  AVERAGE_WEEKLY: "ממוצע שבועי",
  HAS_READ_TODAY: "יש קריאה יומית",
  NOT_READ_TODAY: "אין קריאה יומית",
  READ_TODAY: "קריאה יומית",
  LAST_MONTH: "חודש קודם",
  LAST_YEAR: "שנה קודמת",
  COMPARISON_BY: "השווה לפי",
  BY_EMPLOYEE: "פילוח לפי עובד",
  NOT_RANGE: "לא בזמנים",
  RANGE: "בזמנים",
  REAL_DATA: "מידע אמיתי",
  FAKE_DATA: "מידע פקטיבי",
  SHORTCUT: "קיצורי דרך",
  ACTION: "פעולה",
  MONTHLY_UTILITY: "ממוצע יעילות חודשי ",
  LAST_MONTHLY_UTILITY: "יעילות חודש קודם",
  DEVICES: "מכשירים",
  DEVICE: "מכשיר",
  BUSINESS_ACTIVE: "לקוחות פעילים",
  BUSINESS_PILOT: "לקוחות פילוט",
  BUSINESS_NOT_ACTIVE: "לקוחות לא פעילים",
  BUSINESS_BLOCKED: "לקוחות חסומים",
  SUM_MCS: "סה\"כ בקרים",
  MCS_NOT_CONNECTED: "בקרים לא מחוברים",
  MCS_CONNECTED: "בקרים מחוברים",
  MC_NAME: "שם בקר",
  MCS_COUNT: "כמות בקרים",
  BUSINESS_NEW_IN_YEAR: "לקוחות חדשים השנה",
  BUSINESS_NEW_IN_MONTH: "לקוחות חדשים החודש",
  SERVICE_CALL_OPEN: "קריאות פתוחות",
  SERVICE_CALL_CLOSED: "קריאות סגורות",
  SERVICE_CALL_TO_DAY: "קריאות להיום",
  SERVICE_CALL_WAITING: "קריאות ממתינות",
  PAYMENT_AMOUNT: "סכום לתשלום",
  ACTIVE_RETAINERS: "הוראות קבע פעילות",
  NOT_ACTIVE_RETAINERS: "הוראות קבע לא פעילות",
  BUSINESS_WITHOUT_RETAINER: "לקוחות ללא הוראת קבע",
  DOCUMENTS_IN_YEAR: "מסמכים השנה",
  DOCUMENTS_IN_MONTH: "מסמכים החודש",
  INVOICES_IN_YEAR: "חשבוניות השנה",
  INVOICES_IN_MONTH: "חשבוניות החודש",
  DOCUMENTS: "מסמכים",
  INVOICE: "חשבונית עסקה",
  TAX_INVOICE: "חשבונית מס",
  ORDER: "הזמנה",
  QUOTE: "הצעת מחיר",
  RECEIPT: "קבלה",
  CREDIT_NOTE: "חשבונית זיכוי",
  INVOICES: " חשבוניות עסקה",
  TAX_INVOICES: " חשבוניות מס",
  ORDERS: " הזמנות",
  QUOTES: " הצעות מחיר",
  RECEIPTS: " קבלות",
  CREDIT_NOTES: " חשבוניות זיכוי",
  DOCUMENT_TYPE: "סוג מסמך",
  DOCUMENT_NUMBER: "מס' מסמך",
  ANNUAL_INCOME_IN_YEAR: "הכנסות השנה",
  ANNUAL_INCOME_IN_MONTH: "הכנסות החודש",
  OPEN_ORDERS: "הזמנות פתוחות",
  SHOW_DOCUMENT: "הצג מסמך",
  DUPLICATE_DOC: "חשודים ככפולים",
  IMPORT_DATA: "ייבוא נתונים",
  REVENUE_FORECAST: "צפי הכנסות שנתי",
  EXPENSES_FORECAST: "צפי הוצאות שנתי",
  RETAINER: "ריטיינר",
  ONE_TIME: "חד פעמי",
  FIXED_EXPENSES: "הוצאה קבוע",
  VARIABLE_EXPENSES: "הוצאה משתנה",
  RETAINERS: "הוראות קבע",
  VAT_EXPENSES: 'החזרי מע"מ',
  BUILD_CUSTOMER: "רווח/הפסד לפי לקוח",
  TEN_NOTIFICATIONS: "10 התראות אחרונות",

  /** Business */
  COLOR1: "צבע 1",
  COLOR2: "צבע 2",
  COLOR3: "צבע 3",
  LOGO: "לוגו",
  IMAGE_HEADER: "קאבר לדפי נחיתה",
  LAT_AND_LON: "קו אורך ורוחב",
  DESC_BIZ_TITLE: "כותרת לתיאור העסק",
  DESC_BIZ: "תיאור העסק",
  IS_EXAMPLE: "עסק לתצוגה",
  IS_SYSTEM: "עסק מערכת",
  HAS_SERVICE_MEDIA: "גישה למדיה בקריאות שירות",
  HAS_MC_COMMAND_GROUP: "גישה לקבוצת פקודות בקרים",
  HOTEL_CODE: "מזהה מלון",
  INTERVAL_RETAINER: "מחזור ריטיינר",
  ERP_CLIENT_ID: "מזהה לקוח ERP",

  //new
  BIZ_UPDATED_SUCCESS: "העסק עודכן בהצלחה",
  BIZ_TYPE: "סוג עסק",
  SERVICE_PROVIDER: "נותן שירות",
  MAINTENANCE_DEPARTMENT: "מחלקת אחזקה",
  HOTEL: "מלון",
  FACTORY: "מפעל",

  /** Departments */
  DEPARTMENTS: "מחלקות",
  DEPARTMENT: "מחלקה",
  MANAGER: "מנהל",
  PLUGINS_LIST: "רשימת תוספים",
  ADD_PLUGINS: "הוסף תוסף",
  SELECT_PLUGINS: "בחר תוסף",
  LINKED_PLUGINS: "תוספים מקושרים",
  // new
  IS_DEPARTMENT_BLOCKED: "מחלקה חסומה",
  DEPARTMENT_NAME: "שם המחלקה",
  DEPARTMENT_CLIENT_GUID: "מזהה מחלקה",
  REPORTING_DEPARTMENTS: "מדווחים",
  REPORTING_DEPARTMENT: "מדווח",
  NEW_REPORTING_DEPARTMENT: "מדווח חדש",
  DEPARTMENTS_QTY: "כמות מחלקות",
  MCS: "בקרים",
  MC_LIST: "רשימת בקרים",
  SELECT_MC: "בחר בקר",
  NO_SELECTED_MC_INFO: "מחלקה זו תוכל לראות את כלל הבקרים של העסק",

  /** Employee */
  EMPLOYEES: "עובדים",
  EMPLOYEE: "עובד",
  ALL_EMPLOYEES: "כל העובדים",
  EMPLOYEE_IMG: "תמונת עובד",
  CARDS: "כרטיסים",
  CARD: "כרטיס",
  EMPLOYEE_DETAILS: "פרטי עובד",
  FN: "שם פרטי",
  LN: "שם משפחה",
  BIZ_ROLE: "תפקיד",
  TEL: "טלפון",
  EMAIL: 'דוא"ל',
  OF: "מתוך",
  CARD_QTY: "כמות כרטיסים",
  EMPLOYEES_QTY: "כמות עובדים",
  EMPLOYEES_PATH: "מזהה עובד",
  BUSINESS_CARD: "כרטיס ביקור",
  WEB_APP_PAGE: "דף נחיתה",
  LOGIN_EMP: "כניסת עובד",
  LOGIN_EMP_LINK: "קישור לכניסת עובד",
  OPEN_LINK: "פתח קישור",
  COPY_LINK: "העתק קישור",
  USER_NAME_EXISTS: "שם משתמש קיים במערכת - נא לבחור שם משתמש אחר",
  DELETE_EMPLOYEES: "האם אתה בטוח שברצונך למחוק עובד זה?",
  IS_BO_ALLOWED: "גישה לפאנל",
  HAS_WEB: "דף עובד",
  LOGIN_EMP_LINK_INFO: "הקישור הינו אישי ואינו ניתן להעברה (לכל עובד יש קישור אחר)",
  //new
  EMPLOYEES_QTY: "כמות עובדים",
  EXTRA_BUSINESSES: "עסקים נוספים",
  SECONDARY_EMAIL: 'דוא"ל נוסף',

  /** items */
  SKU: 'מק"ט',
  DESC: "תיאור",
  IS_WEB_SALE: "מוצג באתר",
  NAME: "שם",
  WARRANTY_TIME: "זמן אחריות (בימים)",
  DELETE_ITEM: "האם אתה בטוח שברצונך למחוק ציוד זה?",
  ITEMS_QTY: "כמות ציוד",
  ITEM_DETAILS: "פרטי ציוד",
  ITEM: "ציוד",
  SELECT_ITEMS: "בחר ציוד",

  /** Clients */
  CLIENTS: "לקוחות",
  GET_CLIENTS_ERROR: "שגיאה בייבוא לקוחות",
  CLIENT_GUID: "מזהה לקוח",
  COMPANY: "שם החברה",
  CONTACT_NAME: "איש קשר",
  CLIENT_DETAILS: "פרטי לקוח",
  GUID_EXISTS: "מזהה קיים, נא לבחור מזהה אחר",
  CLIENT_QTY: "כמות לקוחות",
  ITEMS_LIST: "רשימת ציוד",
  ADD_ITEM: "הוסף ציוד",
  ITEMS: "ציוד",
  NEW_CLIENT: "לקוח חדש",
  GUID: "מזהה",
  SELECT_ITEM: "בחר ציוד",
  DELETE_CLIENT: "האם אתה בטוח שברצוך למחוק לקוח זה?",
  ALL_CLIENTS: "כל הלקוחות",
  IS_BLOCKED: "לקוח חסום",
  HAS_CHECK_LIST: "רשימת משימות",

  /** Services call */
  SERVICE_CALL_ACTIVE: "פתוחות",
  SERVICE_CALL_APPROVAL: "סגורות",
  SERVICE_CALL_HISTORY: "היסטוריה",
  SERVICES_CALL: "קריאה/הזמנה",
  CALL_ID: "מס' קריאה",
  OPEN: "פתח",
  SELECT_EMPLOYEE: "עובד משויך",
  PMT_TYPE_ID: "סטטוס חיוב",
  PAY: "לחויב",
  NOT_PAY: "ללא חיוב",
  SERVICE: "שרות",
  WAITING: "ממתין",
  NOTES: "הערות",
  CLIENT_CALL_ID: "מס' קריאה (לקוח)",
  ALL_CALLS: "כל הקריאות",
  JOB_DONE_DESC: "עבודה שבוצעה",
  SELECT_EMP: "בחר עובד",
  DESC_PROBLEM: "תיאור התקלה",
  CREATE_SERVICES: "פתיחת קריאה חדשה",
  IMPORT_CALL: "יבוא קריאות",
  NEW_CALL: "קריאה חדשה",
  RESET: "איפוס",
  DELETE_SERVICES_CALL: "האם אתה בטוח שברצונך למחוק קריאת שירות זו?",
  WORK_DT: "התחלת עבודה",
  DODAY: "היום",
  CLIENT_NAME: "איש קשר",
  ORDER_NUM: "מספר הזמנה",
  INVOICE_NUM: "מספר חשבונית",
  QUOTATION_NUM: "מספר הצעה",
  CREATE_QR: "צור QR",
  S_C: "ק.ש",
  DISPLAY_SETTINGS: "הגדרות תצוגה",
  PROVIDERS: "ספקים",
  CONTENT_WITH_ITEMS: "תיאור התקלה",
  SEND_SEVICES_SUMMARY: "שלח סיכום ביקור",
  OPEN_SEVICES_SUMMARY: "פתח סיכום ביקור",
  CLIENT_NO_EMAIL: 'אין אפשרות לשלוח - ללקוח זה אין דוא"ל',
  CHANGE_DATES: "שינוי תאריכים",
  START: "התחלה",
  END: "סיום",
  PROVIDERS_EXPENSES: "הוצאות ספקים",
  SEND_SUCCESS: "סיכום ביקור נשלח בהצלחה",
  WORK_END_DT: "סיום עבודה",
  WORK_END_DT_ISBEFORE_WORK_DT_ERROR:
    "תאריך סיום לא יכול להיות לפני התחלת העבודה",
  SUBMIT_AND_SEND_SUMMARY: "שמור ושלח סיכום ביקור",
  APPROVAL: "מאושר",
  SELECT_DEPARTMENTS: "בחר מחלקה",
  SELECT_CLIENT: "בחר לקוח",
  CREATE_SERVICE_CALL: "פתח קריאת שירות",
  SERVICE_CALLS: "קריאות שירות",
  //new
  ADD_FAULT: "הוסף תקלה",
  ADD_FAULTS: "הוסף תקלות",
  ADD_ITEMS: "הוסף ציוד",
  CLOSE_SERVICE: "סגור קריאה",
  CHANGE_EMP: "שיוך לעובד",
  ADD_FLAG_SERVICE: "הוסף דגל",
  REMOVE_FLAG_SERVICE: "הסר דגל",
  CHANGE_EMP_SUCCESS: "עובד שוייך בהצלחה לקריאה",
  ELAPSED_TIME: "זמן שעבר",
  ADD_HAS_FALG: "הוסף דגל",
  REMOVE_HAS_FALG: "הסר דגל",
  ADD_HAS_FALG_SUCCESS: "דגל נוסף לקריאה",
  REMOVE_HAS_FALG_SUCCESS: "דגל הוסר מהקריאה",
  WORKS: "עבודות שבוצעו",
  ADD_NEW_WORK: "הוסף עבודה חדשה",
  NO_WORKS_ADDED: "לא נוספו עבודות",
  SUPPLIER_COSTS: "הוצאות לספקים",
  NO_SUPPLIER_COSTS: "לא נוספו הוצאות ספקים",
  ADD_NEW_SUPPLIER_COST: "הוסף הוצאת ספק חדשה",
  SUPPLIER_NAME: "שם ספק",
  COST: "עלות",
  ITEM_NAME: "שם ציוד",
  FINANCIAL_SUMMARY: "סיכום כספי",
  MOVE_TO_BIZ: "מעבר לעסק אחר",
  BIZ_NOT_INCLUDE_PLUGIN: "אין גישה לשירות המבוקש",
  SELECT_BIZ_TO_MOVE: "בחר עסק למעבר",
  LOADING_YOUR_WORKSPACE: "טוען את סביבת העבודה...",
  TIME_FROM_STARTCALL: "זמן מפתיחת הקריאה",
  ALL_COLORS: "כל הצבעים",
  START_TIME: "ש.התחלה",
  END_TIME: "ש.סיום",
  REPLACED_PARTS: "חלקים שהותקנו",
  TOOLS: "כלי עבודה",
  TOOL_NAME: "שם כלי העבודה",
  PARTS: "חלקים",
  SUPPLIER: "ספק",
  CONTINUAL: "דרוש המשך",
  REQUESTED: "בקשת הזמנה",
  ORDERED: "הוזמן",
  ARRIVED: "הגיעה",
  COLLECTED: "נאסף",
  SERVICE_CALL_CONTINUAL_ERROR: "אין אפשרות לסגור את הקריאה - דרוש המשך",

  /**  suppliers */
  NEW_SUPPLIER: "ספק חדש",
  SUPPLIERS: "ספקים",
  SUPPLIER: "ספק",
  DELETE_SUPPLIER: "האם אתה בטוח שברצונך למחוק את הספק ?",

  /** supplier Orders */
  SUPPLIER_ORDERS: "הזמנות מספקים",
  PART_NAME: "שם החלק",
  SERVICE_GUID: "מזהה קריאה",
  NO_PO: "אין הזמנת רכש",
  PO: "הזמנת רכש",


  /** Schedule Services Call */
  SCHEDULE_SERVICES_CALL: "מתוזמנות",
  NOTIFICATION_IN_DAY: "התראה (בימים)",
  FREQUENCY: "מחזוריות",
  NEXT_OCCURRENCE: "קריאה הבאה",
  FREQUENCY_DATA_ERROR: "נא לבחור מחזוריות",
  EMPLOYEE_ERROR: "נא לבחור עובד",
  SELECT_ITEM_OR_CLIENT_ERROR: "נא לבחור ציוד או לקוח",
  FREQUENCY_DAYS_ERROR: "נא לבחור לפחות יום אחד",
  FREQUENCY_TIME_ERROR: "נא לבחור שעה",
  START_DT_ERROR: "נא לבחור תאריך התחלה",
  FREQUENCY_WEEKLY_INTERVAL_ERROR: "נא לבחור כל כמה שבועות יקרה",
  FREQUENCY_MONTHLY_INTERVAL_ERROR: "נא לבחור כל כמה חודשים יקרה",
  FREQUENCY_DAY_INTERVAL_ERROR: "נא לבחור באיזה יום בחודש יקרה",
  FREQUENCY_YEARLY_INTERVAL_ERROR: "נא לבחור כל כמה שנים זה יקרה",

  /** Control And Monitoring */
  CONTROL_AND_MONITORING: "בקרים",
  TEMP1: "אוויר חוזר",
  TEMP2: "אוויר יוצא",
  WATER_TEMP1: "מים חוזרים",
  WATER_TEMP2: "מים יוצאים",
  LOADING_TO_DATA: "ממתין...",
  ACTIVE_DATA: "מצב המזגן",
  ON_MC: "פעיל",
  OFF_MC: "כבוי",
  TEMP_ACTIVE: "טמפ'",
  DHT_ACTIVE: "לחות",
  TEMP: "טמפ'",
  DHT: "לחות",
  DELTA: "דלטה",
  DEHUMIDIFY: "ייבוש",
  HUMIDIFY: "לחות",
  MODE_ACTIVE: "מצב",
  TURN_ON_DATE: "תאריך הפעלה",
  TURN_OFF_DATE: "תאריך כיבוי",
  FAULT: "תקלה",
  FAULTS: "תקלות",
  CLOGGED_FILTER: "מסנן / סוללה / מאיץ מלוכלך",
  HEAVY_CLOGGED_FILTER: "מסנן / סוללה / מאיץ מלוכלך במידה חמורה",
  SENSOR_ERROR: "אחד החיישנים אינו תקין - יש לפנות לשרות לקוחות",
  LACK_GAS: "חוסר גז במזגן",
  COMPRESSOR_NOT_STOP: "מדחס לא עוצר",
  TURN_ON_DATE_INFO_RELAY: "האם להפעיל את המכשיר ?",
  TURN_OFF_DATE_INFO_RELAY: "האם לכבות את המכשיר ?",
  TEMP_OUT_OF_RANGE: "טמפ' מחוץ לטווח התקין",
  SENSOR_DISCONNECTED: "רגש טמפרטורה מנותק",
  B22_POWER_OK: "מחובר למקור החשמל הראשי",
  B22_PARENT_MONITORING: "התראות חשמל ומעבר לסוללת גיבוי",
  B22_HISTORY: "היסטוריית טמפרטורה",
  B22_HISTORY_RANGE: "יש לבחור טווח תקין של עד 31 ימים",
  B22_LOAD_FAILED: "טעינת הנתונים נכשלה",
  RETURN_WATER_TEMP_OUT_OF_RANGE: "טמפ' מים חוזרים מחוץ לטווח התקין",
  RETURN_WATER_TEMP_OUT_OF_RANGE_AND_GENERAL_FAULT: "טמפ' מים חוזרים מחוץ לטווח התקין ותקלה כללית",
  GENERAL_FAULT: "תקלה כללית",
  TEMP_AND_HUM_OUT_OF_RANGE: "טמפרטורה ולחות מחוץ לטווח תקין",
  HUM_OUT_OF_RANGE: "לחות מחוץ לטווח תקין",
  POWER_SOURCE_BATTERY: "בקר עבר לסוללת גיבוי",
  TURN_ON_DEVICE: "להפעיל את",
  TURN_OFF_DEVICE: "לכבות את",
  ALL_AREAS: "כל האזורים",
  MC_IS_DISCONNECTED: "בקר לא מחובר לרשת",
  DELETE_MC: "האם אתה בטוח שברצונך ללמחוק את ההבקר ?",
  STATUS_LED_POWER: "מצב תאורה",
  MIN_SETPOINT: "יעד מינימלי",
  MAX_SETPOINT: "יעד מקסימלי",
  DEAD_BAND: "טווח מת",
  ALL_DEVICE: "כל המוצרים",
  EFFECTIVE: "יעילות",
  LOW_EFFECTIVE: "יעילות נמוכה",
  TEMP_ALERTS: "התראות טמפ'",
  DEVICE_ALERTS: "התראות מכשירים",
  MC_NOT_CONNECTED: "הבקר לא מחובר לרשת",
  ACTIVE_TEMP: "טמפ' נוכחית",
  ACTIVE_DHT: "לחות נוכחית",
  SET_POINT_ACTIVE: "טמפ' רצויה",
  SET_POINT_DHT_ACTIVE: "לחות רצויה",
  SET_POINT_TEMP_ACTIVE: "טמפ' רצויה",
  WATER_LEVEL_HIGH: "רמת מים גבוהה",
  WATER_LEVEL_LOW: "רמת מים נמוכה",
  WATER_LEAK_DETECTED: "זוהתה דליפת מים",
  DOOR_OPEN: "דלת פתוחה",
  WINDOW_OPEN: "חלון פתוח",
  EMERGENCY_STOP: "עצירה חירום",
  FIRE_ALARM: "התראת אש",
  GENERIC_FAULT: "תקלה כללית",
  SELECTED_MC_COUNT: "מספר בקרים שנבחרו",
  GROUP_COMMAND: "פקודה קבוצתית",
  SELECTED_MCS_OFF: "כיבוי בקרים שנבחרו",
  SELECTED_MCS_ON: "הפעלת בקרים שנבחרו",
  EXIT_TEMP: "טמפ' יציאה",
  RETURN_TEMP: "טמפ' חזרה",
  PLACE_TEMP: "טמפ' סביבה",
  NEXT_TIME_ON: "תאריך הפעלה הבא",
  NEXT_TIME_ON_SCHEDULE: "תאריך הפעלה הבא לפי לוח הזמנים",
  RETURN_WATER_TEMP: "מים חוזרים",
  SUPPLY_WATER_TEMP: "מים יוצאים",
  SETTINGS_RETURN_WATER: "הגדרות מים חוזרים",
  UPDATE_MC: "עדכון תוכנה",
  MOVE_TO_ADMIN_MC: "עבור לאזור אדמין",
  MOVE_TO_MANAGER_MC: "עבור לאזור מנהל",

  /** Calendar */
  CALENDAR: "יומן",
  LOCATION: "מיקום",
  AVAILABILITY: "זמינות",
  AVAILABLE: "פנוי/ה",
  BUSY: "עסוק/ה",
  PERSONAL: "אישי",
  VOLUNTEERING: "התנדבות",
  SCHOOL: "לימודים",
  WORK: "עבודה",
  FAMILY: "משפחה",
  DELETE_EVENT: "האם אתה בטוח שברצונך למחוק אירוע זה?",

  /** Meter Reading */
  METER_READING: "מונים",
  METER_ID: "מספר מונה",
  READ_VALUE: "קריאה",
  ELECTRICITY: "חשמל",
  WATER: "מים",
  GAS: "גז",
  METER_READ: "קריאת מונה",
  DELETE_METER_READ: "האם אתה בטוח שברצונך למחוק קריאה זו?",
  CREATED_READ: "תאריך קריאה",
  METER_LAST_READ: "קריאה אחרונה במונה",
  ERROR_DAY: "בוצעה קריאה יומית",
  WATER_QTY: "קוב",
  ELECTRICITY_QTY: 'ק"ווט',
  GAS_QTY: 'מ"ק',
  //new
  IS_NOT_BETWEEN_RANGE: "מחוץ לשעות",
  READ_IS_EXCEED: "חורג מהמגבלה",
  CHLORINE: "כלור",
  CHLORINE_QTY: 'מ"ל',
  CONSUMPTION: "צריכה בפועל",
  METER_NOT_FOUND: "מונה לא נמצא",
  CREATE_METER_READ: "קריאת מונה חדשה",
  OFF_PEAK_VALUE: "שפל",
  MID_PEAK_VALUE: "גבע",
  ON_PEAK_VALUE: "פסגה",
  LAST_READ_VALUE: "קריאה קודמת",

  /** meter */
  METER_NAME: "שם/מיקום",
  METER_GUID: "מספר מונה",
  METERS: "מונים",
  THERE_ARE_NO_METERS: "אין מונים זמנים לקריאה, יש לפתוח מונה לפני קריאה",
  SELECT_METER: "בחר מונה",
  //new
  EXCEEDING_LIMIT: "אחוז חריגה להתראה",
  RECOMMEND_TIME_READ: "זמן מומלץ למדידה",
  METER: "מונה",
  IS_METER_ACTIVE: "מונה פעיל",
  FIRST_READ_VALUE: "קריאה ראשונית",
  IS_TARIFF: "מונה רב-תעריפי",

  /** Settings */
  BIZ_SETTINGS: "הגדרות עסק",
  BIZ_NAME: "שם העסק",
  ADDR: "מיקום",
  SETTINGS_CONTROL_AND_MONITORING: "הגדרות בקרים",

  /** contact us */
  CONTACT_US: "צור קשר",

  /** Schedule */
  SCHEDULE: "לוח זמנים",

  /** MC Installation */
  ACTIVATE_SIM: " הפעלת סים",
  FINISH_INSTALLATION: "סיום התקנה",

  /** Micro Controllers Manager */
  MICRO_CONTROLLERS_MANAGER: "ניהול בקרים",
  MICRO_CONTROLLERS: "בקרים",
  MICRO_CONTROLLER: "בקר",
  MICRO_CONTROLLER_DETAILS: "פרטי בקר",
  FOR_CONFIRM_FACTORY_RESET: "לאיפוס הגדרות יצרן",
  ERROR_FACTORY_RESET_NOT_CONNECTED: "לא ניתן לבצע איפוס הגדרות יצרן, הבקר לא מחובר לרשת",
  FACTORY_RESET_SUCCESS: "איפוס הגדרות יצרן בוצע בהצלחה, הבקר מתאפס ועובר למצב הפעלה מחדש",
  FACTORY_RESET_ERROR: "שגיאה באיפוס הגדרות יצרן, אנא נסה שנית",
  AIR_CONDITIONER: "מזגן",
  LIGHTING: "תאורה",
  WATER_PUMP: "משאבת מים",
  BOILER: "דוד חימום",
  GENERATOR: "גנרטור",
  COMPRESSOR: "מדחס",
  ELEVATOR: "מעלית",
  REFRIGERATION: "חדר קירור",
  FREEZER_ROOM: "חדר הקפאה",
  REFRIGERATOR: "מקרר",
  FREEZER: "מקפיא",
  RELAY: "ממסר",
  HVAC: "מערכת אוורור",
  GATE: "שער חשמלי",
  SOLAR: "מערכת סולארית",
  FIRE_SYSTEM: "מערכת כיבוי אש",
  IRRIGATION: "מערכת השקיה",
  MACHINE: "מכונה תעשייתית",
  STEAM_SYSTEM: "  מערכת קיטור",
  ELECTRICAL_ROOM: "חדר חשמל",

  IS_LINKED_MC: "בקר צרוב",
  MC_NOT_FOUND: "בקר לא נמצא",
  CHECK_ACTIVATED: "בדיקת בקר",
  MC_HAPPY: "בקר תקין",
  MICRO_CONTROLLER_CREATE: "יצירת בקר",
  DELETE_MICRO_CONTROLLER: "האם אתה בטוח שברצונך למחוק בקר זה?",
  ACTIVATED: "הפעלה",
  MINI_DETAILS: "פרטים ראשוניים",
  CONNECT_TO_WIFI: "התחברות לרשת",
  MC_CONNECTED: "בקר מחובר לרשת",
  MC_CONNECTED_STATUS: "סטטוס חיבור לרשת",
  CONNECTED: "מחובר",
  DISCONNECTED: "לא מחובר",
  MC_DISCONNECTED: "בקר לא מחובר לרשת",
  MC_ACTIVATED: "בקר כבר בשימוש",
  OUTSIDE_WORKING_HOURS: "מחוץ לשעות העבודה",
  OUTSIDE_WORKING_HOURS_MSG: "הפעלת המכשיר מחוץ לשעות העבודה",
  OUTSIDE_WORKING_HOURS_MSG_1: "כמה זמן להפעיל את המכשיר?",
  ONE_HOUR: "שעה",
  TWO_HOURS: "שעתיים",
  THREE_HOURS: "שלוש שעות",
  FOUR_HOURS: "ארבע שעות",
  SOFTWARE_TYPE: "תוכנה",
  SOFTWARE_VERSION: "גרסת תוכנה",
  UPDATE_MC_SOFTWARE: "עדכון תוכנת בקר",
  UPDATE_MC_SOFTWARE_SUCCESS: "עדכון תוכנת בקר בוצע בהצלחה",
  UPDATE_MC_SOFTWARE_ERROR: "שגיאה בעדכון תוכנת בקר, אנא נסה שנית",
  MC_GUID: "מזהה בקר (GUID)",
  SIM_ID: "מזהה סים (ICCID)",
  LINK_TO_BUSINESS: "משוייך לעסק",
  GUID_COPY_SUCCESSFULLY: "מזהה הועתק בהצלחה",
  SIM_ID_COPY_SUCCESSFULLY: "מזהה סים הועתק בהצלחה",
  MODEM_IMEI_COPY_SUCCESSFULLY: "מזהה מודם הועתק בהצלחה",
  FACTORY_RESET: "איפוס להגדרות יצרן",
  DELETE_TEMP_DATA: "מחיקת נתוני טמפ'",
  CONNECTED_STATUS: "חיבור",
  ERROR_MC_NOT_CONNECTED: "לא ניתן לבצע את הפעולה, הבקר לא מחובר לרשת",
  DEVICE_TYPE: "סוג ציוד",
  ERROR_CHANGE_BIZ_MC_NOT_CONNECTED: "לא ניתן לשנות את העסק של הבקר, הבקר לא מחובר לרשת",
  ERROR_CHANGE_DEAD_BAND_MC_NOT_CONNECTED: "לא ניתן לשנות את טווח המת של הבקר, הבקר לא מחובר לרשת",
  ERROR_CHANGE_WEEKLY_TIMES_MC_NOT_CONNECTED: "לא ניתן לשנות את לוח הזמנים של הבקר, הבקר לא מחובר לרשת",
  ERROR_MIN_SETPOINT_MUST_BE_LESS_THAN_MAX_SETPOINT: " הטמפ' המקסימלית חייבת להיות גבוהה מהטמפ' המינימלית",
  MIN_TEMP_TOO_CLOSE_TO_MAX: "הטמפרטורה המינימלית חייבת להיות נמוכה לפחות ב־5° מהטמפרטורה המקסימלית.",
  ST_LOCATION: "מיקום",
  TRANSIT: "בדרך/בהובלה",
  STORAGE: "מחסן",
  IN_TECHNICIAN: "אצל טכנאי",
  INSTALLATION: "בתהליך התקנה",
  LAB: "מעבדה",
  REPAIR: "בתיקון",
  CUSTOMER: "אצל לקוח",
  TURNOFF_LED_SUCCESS: "התאורה כובתה בהצלחה",
  TURNON_LED_SUCCESS: "התאורה נדלקה בהצלחה",
  HAS_TEMP_SENSOR: "יש חיישן טמפ'",
  OK: "תקין",
  FAULTY: "תקול",
  DECOMMISSIONING: "מיועד להשבתה",
  DECOMMISSIONED: "הושבת",
  HEALTH_STATUS: " מצב תקינות",
  MIN_TEMP: "מינ' טמפ'",
  MAX_TEMP: "מקס' טמפ'",
  MIN_DHT: "מינ' לחות",
  MAX_DHT: "מקס' לחות",
  FAULT_DELAY_TIME: "השהיה לפני התראת טמפרטורה",
  POWER_LOSS_DELAY_TIME: "השהיה לפני התראת איבוד חשמל",
  HAS_DISCONNECTED_NOTIFICATION: "יש התראת על ניתוק מהרשת",
  DISCONNECTED_DELAY_TIME: "השהיה לפני התראת ניתוק מהרשת (מינימום 10 דקות)",

  MC_GUID_NOT_FOUND: "מזהה בקר לא תקין",
  FLASH: "צריבה",
  UPDATE_MC_SOFTWARE_VALIDATION: "הזן 4 ספרות אחרונות של הבקר",

  MODEM_IMEI: "מזהה מודם",
  ADD_MC_AND_CLICK_SEARCH: "חבר את הבקר למחשב ולחץ על כפתור \"חיפוש\"",
  STICKER: "מדבקת מידע",
  SEARCH_BY_DEVICE: "חיפוש לפי חומרה",
  CREATE_MCS: "הוספת בקרים",
  CREATE: "הוסף",
  FLASH_MC: "צריבת בקר",
  ROOM_ID: "מזהה חדר",
  MANUAL: "ידנית",
  PRINT_MC_NAME: "מדבקת התקנה",
  RELAY_WHEN_FAULT: "הפעלת ממסר בעת תקלה",
  RELAY_WHEN_NOT_FAULT: "הפעלת ממסר בעת תקינות",
  SENSOR_FAULT_TYPE: "סוג תקלה",
  FAULT_MASSAGE: "הודעת תקלה",
  SENSOR_OPEN: "חיישן לא בקצר",
  SENSOR_CLOSED: "חיישן בקצר",
  CLOSE_RELAY: "סגור ממסר",
  OPEN_RELAY: "פתח ממסר",
  NO_CHANGE: "אין שינוי",
  ERROR_CHANGE_MC_NOT_CONNECTED: "לא ניתן לשנות את הגדרות הבקר, הבקר לא מחובר לרשת",
  DHT_SETPOINT: "לחות יעד",
  SYSTEM_SETTINGS: "הגדרות תוכנה",

  B1_0: "B1.0",
  B1_1: "B1.1",
  B1_3: "B1.3",
  B1_4: "B1.4",
  B1_5: "B1.5",
  B1_6: "B1.6",
  B1_7: "B1.7",
  B1_8: "B1.8",
  B1_9: "B1.9",
  B2_0: "B2.0",
  B2_1: "B2.1",
  B2_2: "B2.2",
  MC_MODEL: "דגם",
  HAS_CONTACT_SENSOR: "יש חיישן מגע",
  FAULT_CHECK_ROUNDS: "זמן השהיה לפני בדיקות",
  SUSPEND_SIM: "סגור סים",
  ACTIVATE_SIM: "הפעל סים",
  SUSPENDED: "מושהה",
  CHANGE_ST_SIM_SUCCESS: "הבקשה נקלטה, העדכון יתבצע תוך מספר דקות",
  IN_PROCESS: "בתהליך...",
  CALL: "שיחה",
  OFFSET_SETTINGS: "הגדרות כיול",
  SENSOR1_OFFSET: "כיול חיישן 1",
  SENSOR2_OFFSET: "כיול חיישן 2",


  /** Areas */
  AREAS: "אזורים",
  AREA: "אזור",
  DELETE_AREA: "האם אתה בטוח שברצונך למחוק אזור זה ?",
  NO_AREA: "לא משוייך לאזור",

  /** Webapp Message */
  WEBAPP_MESSAGE: "דואר",
  OPEN_MESSAGE: "פתח הודעה",
  FULL_NAME: "איש קשר",
  IS_READ: "סטטוס הודעה",
  MESSAGE: "הודעה",
  READ: "הודעה נקרא",
  NOT_READ: "הודעה לא נקרא",
  SELECTED_EMP: "בחר עובד",

  /** support */
  SUPPORT: "תמיכה",
  SUPPORT_SUBJECT: "נושא הפניה",
  SUPPORT_MESSAGE: "תוכן הפניה",
  TECHNICAL_ISSUE_HELP: "בעיה טכנית במערכת – דרוש סיוע",
  LOGIN_ERROR: "תקלה בהתחברות לחשבון",
  USAGE_QUESTION: "שאלה טכנית בנוגע לשימוש במערכת",
  BUG_REPORT: "דיווח על באג או התנהגות לא צפויה",
  SUPPORT_SUCCESS: "פניה נפתחה בהצלחה",
  SUPPORT_NUMBER: "מס' פניה",
  SAVE_SUPPORT_NUMBER: "מומלץ לשמור את מספר הפנייה לצורך מעקב עתידי ועד לסיום הטיפול",
  SUPPORT_RECEIVED_1: "פנייתך נקלטה במערכת.",
  SUPPORT_RECEIVED_2: "נציג מטעמנו ייצור עמך קשר בהקדם.",

  /** business manager */
  BUSINESS_MANAGER: "ניהול עסקים",
  BUSINESS: "עסקים",
  EXAMPLE: "תצוגה",
  SYSTEM_BUSINESS: "עסקי מערכת",
  NAVIGATE_BUSINESS: "עבור לעסק",
  PATH: "מזהה",

  /** Ac Commands*/
  BRAND: "מותג",
  MODEL: "דגם",
  VERSION: "גירסה",
  YEAR_MANUFACTURE: "שנת ייצור",
  REGION: "אזור מכיה",
  ON: "הפעלה",
  OFF: "כיבוי",
  VENT: "אוורור",
  COOL: "קור",
  HEAT: "חום",
  DRY: "ייבוש",
  AUTO: "אוטומטי",
  ECO: "חסכוני",
  SLEEP: "שינה",
  TURBO: "טורבו",
  DEGREES: "מעלות",
  PROTOCOL: "פרוטוקול",
  BITS: "כמות ביטים",
  MODES: "מצבי עבודה",
  POWER: "כיבוי והדלקה",
  POWER_COMMANDS: "הפעלה ומצבי עבודה",
  TEMPS_COMMANDS: "טמפ'",
  AC_COMMANDS_MANAGER: "פקודת מזגנים",
  FAN_SPEED: "עוצמת מפוח",
  LOW: "נמוך",
  MEDIUM: "בינוני",
  HIGH: "גבוה",
  COMMANDS: "פקודות",
  SELECT_COMMAND: "שייך פקודות (בדרך כלל לפי מותג ודגם המזגן)",
  TEST_COMMAND_SUCCESS: "בדיקה נשלחה לבקר - אם הפקודה נקלטה המזגן צריך להדלק",
  COMMAND_NOE_FOUND_ERROR: "יש לבחור מותג מזגן",
  WEEKLY_TIMES: "לוח זמנים",
  RELAY: "ממסר",
  DIFFERENCE: "הפרש",

  /** Check List */
  CHECK_LIST: "משימות",
  NO_CHECK_LIST: "אין משימות",
  CHECK_LIST_CLOSED: "משימות סגורות",
  CHECK_LIST_OPENED: "משימות פתוחות",
  TASKS: "משימות",
  NO_RECORDS: "אין פרוייקטים",
  RECORDS: "פרוייקטים",
  CLOSED_DATE: "תאריך סגירה",
  DELETE_CHECK_LIST_ITEM: "האם אתה בטוח שברצונך למחוק משימה זו ?",


  /** reports */
  REPORTS: "דוחות",
  INVOICE_STATUS: "סטטוס מספר חשבונית",
  METER_READ_REPORT: "קריאות מונה",
  TEMP_REPORT: "דוח טמפרטורה",
  HACCP_REPORT: "דוח בקרת טמפרטורה",
  MONITORING_PARENT: "בקר אב",
  MONITORING_COMMANDS: "הפעלה ופקודות",
  HACCP_EXPORT_PDF: "הורדת PDF",
  HACCP_CONTENTS: "תוכן עניינים לפי תאריך",
  HACCP_MEASUREMENTS: "מספר מדידות",
  HACCP_EVENTS: "סיכום אירועי התראת טמפרטורה",
  HACCP_EVENTS_NOTE: "לפי דגל ההתראה שדיווח הבקר, בנפרד מיציאה מספרית מהטווח. הזמנים והמשך מבוססים על המדידות שהתקבלו, ולא על זמן תחילת החריגה או שליחת הודעה ללקוח. ללא אישור סיום, המשך נמדד עד המדידה החריגה האחרונה בלבד.",
  HACCP_EVENT_START: "זיהוי התראה ראשון",
  HACCP_EVENT_END: "זיהוי סיום התראה",
  HACCP_EVENT_DURATION: "משך נצפה (דקות)",
  HACCP_EVENT_MIN: "מינימום °C",
  HACCP_EVENT_MAX: "מקסימום °C",
  HACCP_EVENT_ENDED: "דווח סיום התראה",
  HACCP_EVENT_GAP: "רציפות לא ידועה",
  HACCP_EVENT_OPEN: "לא התקבל אישור סיום בטווח הדוח",
  HACCP_NOTICE: "בדיקה מול גבולות המכשיר שנשמרו עם המדידה; אינה אישור עמידה כולל ב-HACCP או בדרישות משרד הבריאות. מדידות ישנות ללא גבולות היסטוריים אינן ניתנות להערכה.",
  HACCP_INTERVAL: "מרווח דיווח צפוי בדקות",
  HACCP_LIMITS: "גבולות שנשמרו (°C)",
  HACCP_STATUS: "תוצאת בדיקה",
  HACCP_IN_RANGE: "בטווח שהוגדר",
  HACCP_DEVIATION: "מחוץ לטווח שהוגדר",
  HACCP_UNKNOWN: "אין מספיק מידע",
  HACCP_GAPS: "מרווחים ללא נתונים",
  HACCP_GAP_NOTICE: "לפי מרווח דיווח של 5 דקות וסבילות של 50%. אין להסיק מכך שהטמפרטורה הייתה תקינה או שלא בוצעה מדידה. הזמנים הם זמני קבלה בשרת.",
  HACCP_EXPORT: "יצוא Excel",
  HACCP_LOADING: "טוען דוח…",
  TEMP_AVG_REPORT: "דוח טמפרטורה ",
  DHT_AVG_REPORT: "דוח לחות",
  HOURLY_AVERAGE: "מומצע שעתי",
  SELECT_MC_ERROR: "נא לבחור בקר",
  TEMP_IN_PLACE: "טמפ' במקום",
  YEARLY_SERVICE_CALL_REPORT: " דוח קריאות שירות שנתי",
  INCOME: " הכנסות",
  EXPENSES: "הוצאות",
  PROFIT: "רווח",
  LOSS: "הפסד",
  PROFIT_OR_LOSS: "רווח/הפסד",
  ALERTS: "חריגים",
  ALL_DATA: "כל הנתונים",
  RELAY_POWER_REPORT: "דוח הפעלה/כיבוי",


  /** mini site */
  MINI_SITE: "אתר",
  MINI_SITES: "אתרים",
  DELETE_MINI_SITE: "האם אתה בטוח שברצונך למחוק אתר זה ?",
  WITHOUT_CLIENT: "ללא לקוח",
  SEND_SITE: "שלח קישור לפתיחת קריאת שירות",
  LINK_SENDING: "לינק נשלח בהצלחה",
  LINK_SENDING_ERROR: "שגיאה בשליחת לינק",
  SELECT_CONTACT: "בחר מרשימת אנשי הקשר",
  CONTACTS_SELECTED_SUCCESS: "איש קשר נבחר בהצלחה",
  HAS_SERVICE_SUMMARY_MINI_SITE: "רשימת ביקורים באתר",
  HIDE_CLIENT_DETAILS: "הסתר פרטי לקוח",
  HAS_APP: "יש אפליקציה",
  HIDE_CLIENT_CALL_ID: "הסתר מס' קריאה ללקוח",

  /** colors name */
  WHITE: "לבן",
  LIGHT_PINK: "ורוד",
  LIGHT_YELLOW: "צהוב",
  PALE_GREEN: "ירוק",
  LIGHT_BLUE: "כחול",
  OFF_WHITE: "שמנת",
  LIGHT_LAVENDER: "לבנדר",
  SOFT_RED: "אדום",
  SOFT_CYAN: "תכלת",
  SOFT_GOLD: "זהב",
  SOFT_MINT: "מנטה",
  SOFT_LILAC: "לילך",

  /** Request */
  PERMISSION: "הרשאות",
  REQUEST_NOTIFICATION: "לקבלת התראות לחץ כאן",
  AUTHORIZE_ACCESS: "קבל",
  REQUEST_NOTIFICATION: "התראות",
  PERMISSION_MSG1: "המערכת שלנו זקוקה להרשאות הבאות כדי לספק לך חוויה מיטבית.",
  PERMISSION_MSG2: "אנא אשר/י גישה להתראות הבאות :",

  /** create Google Calendar */
  GOOGLE_CALENDAR_SERVICE_TITLE: "קריאה",
  GOOGLE_CALENDAR_SERVICE_DESCRIPTION: "לפרטים נוספים לחץ על הקישור הבא",
  CREATE_GOOGLE_CALENDAR: "הוסף ליומן גוגל",

  /** Logs */
  LOGS: "לוגים",
  LOGS_DELETE_SUCCESS: "הלוגים נמחקו בהצלחה",
  LOGS_DELETE_ERROR: "שגיאה במחיקת הלוגים, נא לנסות שנית",

  /** Profile */
  PROFILE: "פרופיל",


  /** Mc Request */
  SCAN_SITE: "סיור שטח",
  SELECT_BIZ: "בחר עסק",
  CREATE_BIZ: "פתיחת עסק",
  CREATE_AREA: "פתיחת אזור",
  WAITING_FLASH: "ממתין לצריבה",
  IN_PROGRESS: "בתהליך צריבה",
  COMPLETED: "בקר מוכן",

  /** Notification */
  NOTIFICATION: "התראות",
  NOTIFICATION_IS_ACTIVE: "התראות פעילות",
  NOTIFICATION_NOT_ACTIVE_INFO: "לא יישלחו התראות לבקר זה, מומלץ להפעיל את ההתראות בהקדם.",
  READ_BY: "נקראה ע\"י",
  NOTIFICATION_SETTINGS: "הגדרות התראה",
  DELETE_NOTIFICATION: " האם אתה בטוח שברצונך למחוק התראה זו ?",

  /* system */
  ADMIN: "מנהל כללי",
  SUB_ADMIN: "סגן מנהל כללי",
  INFRASTRUCTURE_SCANNER: "סורק אתרים",
  SERVICE_TECHNICIAN: "תמיכה טכנית",
  SALES_REPRESENTATIVE: "מוכר",
  TECHNICIAN: "טכנאי",
};

export default he;
